// extracted by mini-css-extract-plugin
export default {"btn":"PaginationBtn_btn__s-lDG","disabled":"PaginationBtn_disabled__m8H7S","btn__loader":"PaginationBtn_btn__loader__OiP8Q"};